// extracted by mini-css-extract-plugin
export default {"flexBox":"style_flexBox__tAiz1","flexLink":"style_flexLink__K+i8g","marginLg":"style_marginLg__XwJLr","marginMd":"style_marginMd__r3ebU","active":"style_active__Q2pcX"};